import { Component, ElementRef, inject, viewChildren } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AssistantTab } from '@core/models/assistant/assistant.model';
import { AssistantService } from '@core/services/assistant/assistant.service';
import { ICONS } from '@core/services/icons/icons.service';

@Component({
  selector: 'app-assistant-tabs',
  imports: [TranslatePipe],
  templateUrl: './assistant-tabs.component.html',
  styles: ``
})
export class AssistantTabsComponent {
  protected readonly assistant = inject(AssistantService);
  protected readonly ICONS = ICONS;
  private readonly tabButtons = viewChildren<ElementRef<HTMLButtonElement>>('tabButton');

  protected title(tab: AssistantTab): string | null {
    return tab.messages.find((m) => m.role === 'user')?.text ?? null;
  }

  protected onKeydown(event: KeyboardEvent, index: number): void {
    const tabs = this.assistant.tabs();
    if (event.key === 'Delete') {
      event.preventDefault();
      this.assistant.closeTab(tabs[index].id);
      return;
    }
    const step: Record<string, number> = { ArrowRight: 1, ArrowLeft: -1 };
    const target =
      event.key === 'Home'
        ? 0
        : event.key === 'End'
          ? tabs.length - 1
          : event.key in step
            ? (index + step[event.key] + tabs.length) % tabs.length
            : null;
    if (target === null) return;
    event.preventDefault();
    this.assistant.selectTab(tabs[target].id);
    this.tabButtons()[target]?.nativeElement.focus();
  }
}
